import { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetch(`${API}/settings`)
      .then(r => r.json())
      .then(setSettings)
      .catch(() => setSettings({}));
  }, []);

  if (!settings) return null;

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);